<template>
  <div v-if="showPopIdsSlider" id="popIdentifierSlider" refs="popIdentifierSlider"
    :data-elheight="elementHeight"
    :class="['top-slider-filter', accessorComponent, {
    'expanded': expanded,
    'media-page-popIds-slider': isComponentUseInFilesPage
    }]">
    <div class="background white-background"></div>

    <perfect-scrollbar
      id="popIdsSliderPresentation"
      ref="popIdsSliderPresentation"
      :class="['workspace cstm-ps-scrollbar-vertical', {'has-data': popIds.length, 'hide-ps-rail-y-onHover': !expanded}]"
      @ps-scroll-y="handleContentScrollY">

      <draggable
        v-bind="sortDraggableOptions"
        id="popIdentifierSliderContent"
        class="workspace"
        tag="div"
        ghost-class="sortable-ghost"
        filter=".all"
        :preventOnFilter="true"
        :list="popIds"
        :item-key="(item) => item?.value"
        :group="{ name: 'tags-shared', pull: 'clone', put: false }"
        :sort="false"
        :disabled="isComponentUseInSchedulePageAllPlayers || isComponentUseInMediaPicker"
        :forceFallback="true"
        :move="handleDraggableMove"
        @end="handleDraggableEnd"
      >
        <template #item="{ element: popId, index: indx }">
          <div
            :class="[`el-tag-${accessorComponent}`,
              'el-tag-popId',
              'pop-identifier-item', {
              'selected': selectedPopIds.find(p => p.value === popId.value) || (popId.value === CONST.ALL_TAG_VALUE && selectedPopIds.length === 0),
              'edit-popId': editPopIds.find(t => t.value === popId.value),
              'all': popId.value === CONST.ALL_TAG_VALUE
              }]"
            data-draggable-type="popId"
            :data-draggable-value="popId.value"
            >
            <div class="popIdItem-slider-display">
              <div class="base">
                <div class="text">{{popId.label}}</div>
                <el-input
                  id="popid-slider-input"
                  :model-value="editPopIdValue"
                  @update:model-value="newValue => editPopIdValue = newValue"
                  :ref='`editPopIdInput${indx}`'
                  @blur="handleConfirmEditPopId(editPopIdValue, popId.value)"
                  class="edit-popId-input">
              </el-input>
              </div>
              <div class="pop-icon"></div>
            </div>

            <div class="pop-identifier-item-cover"
              @click="handlePopIdItemClick($event, popId, indx)"
              @mouseover="handlePopIdHover($event, 'mouseover')"
              @mouseout="handlePopIdHover($event, 'mouseout')">
            </div>

            <div v-if="showDeleteAction" @click="confirmDeletePopId($event, popId, indx)" class="remove-icon"></div>
          </div>
        </template>
      </draggable>
    </perfect-scrollbar>

    <div id="popIdSliderCollapseIcon"
      :class="[{'show-icon': showExpandIcon, 'expanded': expanded}]"
      @click="handleExpandComponentIconClick({event: $event})">
      <el-icon :size="20"><ArrowDown /></el-icon>
    </div>
  </div>
</template>

<script src="./pop-identifier-slider.js"></script>
<style lang="scss" src="./pop-identifier-slider.scss"></style>
